export default __webpack_public_path__ + "static/media/presenterNewIcon.bd33dbc1.svg";